export default {
  'Watermark': 'Watermark',
  'Add Watermark Selection': 'Add Watermark Selection',
}